import {
  isJenkinsCustomEnv,
  isJenkinsTestimIoCustomEnv,
  isLandingUiStagingDomain,
  isLocalHostMode,
  Log,
} from "@ryde/shared";

export interface ILandingPageEnvironmentConfig {
  local: number;
  staging: number;
  production: number;
}

export const LANDING_PAGES_CONFIG: Record<
  string,
  ILandingPageEnvironmentConfig
> = {
  Herzliya: {
    local: 68,
    staging: 18,
    production: 68,
  },
  Tnufa: {
    local: 73,
    staging: 22,
    production: 73,
  },
  Clal: {
    local: 74,
    staging: 23,
    production: 74,
  },
  WestNegev: {
    local: 60,
    staging: 14,
    production: 60,
  },
  NvidiaShuttle: {
    local: 71,
    staging: 46,
    production: 71,
  },
  Wix: {
    local: 18,
    staging: 12,
    production: 18,
  },
};

const getEnvironment = (): "local" | "staging" | "production" => {
  if (isLocalHostMode()) {
    return "local";
  }
  if (
    isLandingUiStagingDomain() ||
    isJenkinsCustomEnv() ||
    isJenkinsTestimIoCustomEnv()
  ) {
    return "staging";
  }
  return "production";
};

const currentEnv = getEnvironment();

export const LandingCompanyIdEnum = {
  Herzliya: LANDING_PAGES_CONFIG.Herzliya[currentEnv],
  Tnufa: LANDING_PAGES_CONFIG.Tnufa[currentEnv],
  Clal: LANDING_PAGES_CONFIG.Clal[currentEnv],
  WestNegev: LANDING_PAGES_CONFIG.WestNegev[currentEnv],
  NvidiaShuttle: LANDING_PAGES_CONFIG.NvidiaShuttle[currentEnv],
  Wix: LANDING_PAGES_CONFIG.Wix[currentEnv],
} as const;

Log.debug("[LANDING CONFIG] Company IDs:", LandingCompanyIdEnum);

export type TLandingCompanyId =
  (typeof LandingCompanyIdEnum)[keyof typeof LandingCompanyIdEnum];

export enum LandingCompanyNameEnum {
  Clal = "clal",
  Tnufa = "tnufa",
  Herzliya = "herzliya",
  WestNegev = "westnegev",
  NvidiaShuttle = "nvidiashuttle",
  Wix = "wix",
}
